import { ChemicalRevision } from '../types';

export function createChemicalRevision(
	payload: Partial<ChemicalRevision>,
): Partial<ChemicalRevision> {
	if (!payload.regulationNumber) {
		throw new Error('An EPA regulation number is required');
	}

	if (!payload.expiresAt) {
		throw new Error('An expiration date is required');
	}

	return {
		...payload,
		regulationNumber: payload.regulationNumber,
		expiresAt: payload.expiresAt,
		archivedAt: payload.archivedAt ?? null,
		notes: payload.notes ?? null,
	};
}

/**
 * Checks if a new chemical revision should be created based on changes to the EPA Regulation Number.
 * A new revision is only needed if the regulation number changes.
 * Changes to expiration date or notes do not require a new revision.
 *
 * @param prev The existing revision to compare against
 * @param newRegulationNumber The new regulation number value
 * @returns true if a new revision should be created, false otherwise
 */
export function shouldCreateNewRevision(
	prev: ChemicalRevision | null,
	next: Partial<ChemicalRevision>,
): boolean {
	if (!prev || !next) {
		throw Error('Previous and next revision is required');
	}

	if (prev.regulationNumber !== next.regulationNumber) return true;

	return false;
}
